import { isAlphanumericWithSpaces } from './isAlphanumericWithSpaces';

export const isInvalidNickname = (value?: string) =>
  value &&
  (!isAlphanumericWithSpaces(value) || value.length > 30);
